import { render, staticRenderFns } from "./next_cider_card.vue?vue&type=template&id=fdc65e82&scoped=true"
import script from "./next_cider_card.vue?vue&type=script&lang=js"
export * from "./next_cider_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc65e82",
  null
  
)

export default component.exports